<div class="card">
  <div class="card-header">
    <div style="float: left" (click)="navigationLink('', null)">
      <a href="javascript: void(0);">{{ 'File Manager ' }} </a>
    </div>
    <div *ngIf="showBreadCrumpath">
      <div style="float: left" *ngFor="let bread of breadcrumbs; let count = index"
        (click)="navigationLink(bread, count)">
        {{ ' / ' }}
        <a href="javascript: void(0);">{{ bread }}</a>
      </div>
    </div>
  </div>
</div>

<!-- <div *ngIf="showSpinner" class="center-all">
  <i class="fa fa-spinner fa-spin" style="font-size: 35px; color: #37669e"></i>
</div> -->

<div class="container" id="mainBodyContainer">
  <div class="row m-t-10" *ngIf="!isDeleteAllSelected">
    <!-- <div class="col-md-4"></div> -->
    <div class="col-md-5 text-body m-b-10 search-panel" *ngIf="false">
      <div class="search-bg">
        <label class="toggle-label">
          <input type="checkbox" />
          <span class="back" style="top: 0">
            <span class="toggle"></span>
            <span class="label on" (click)="getTypeToSerch($event)">NAME</span>
            <span class="label off" (click)="getTypeToSerch($event)">TAG</span>
          </span>
        </label>

        <div class="input-group add-on fl-r w-60">
          <input class="form-control" [formControl]="uploadForm.controls['searchByValue']" placeholder="Search"
            name="srch-term" id="srch-term" type="text" style="width: 60%; float: right"
            (keyup)="searchFileName($event)" />
          <div class="input-group-btn">
            <i class="fa fa-search" style="font-size: 18px"></i>
          </div>
        </div>
      </div>
      <div *ngIf="searchResultsList.length > 0" class="search-result">
        <div *ngFor="let searchResult of searchResultsList" style="cursor:pointer;">
          <i aria-hidden="true"
            [ngClass]="searchResult.recordType == 'file' ? getFileIcon(searchResult.recordName) : 'fa fa-folder-open'"></i>
          <span (click)="serachFileRedirect(searchResult)">{{searchResult.recordName}}</span>
        </div>
      </div>
    </div>
    <div class="col-md-3 text-body " *ngIf="false && (sharedFolder == 'false' || sharedFolder  == undefined)">
      <!-- <div class="col-md-5 upload-btn-wrapper">
        <button class="button button1">UPLOAD</button>
        <input type="file" name="file" (change)="fileEvent($event)"
          accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4" />
      </div> -->
      <button class="button button1" (click)="addNewFolder()">
        <i class="fa fa-plus" aria-hidden="true"></i> FOLDER
      </button>
    </div>
    <div class="col-md-4 text-body">
    </div>
  </div>
  <div *ngIf="isDeleteAllSelected">
    <button class="btn btn-primary btn-sm" (click)="cancleSelectedList()">
      Cancel
    </button>
    <button class="btn btn-danger btn-sm" (click)="confirmMultipleDelete()">
      Delete selected
    </button>
  </div>
  <div class="row m-t-60">
    <div class="container-box" appDragndrop (fileDropped)="onFileDropped($event)">
      <input class="input-box" [disabled]="this.showSpinner==true" type="file" #fileDropRef id="fileDropRef" multiple  (change)="fileBrowseHandler($event.target.files)" />
      
      <svg xmlns="http://www.w3.org/2000/svg" width="63" height="64" viewBox="0 0 63 64">
        <g fill="#4A90E2" fill-rule="nonzero">
          <path
            d="M42.656 15.135a1.953 1.953 0 0 1-1.391-.578L31.5 4.795l-9.765 9.762a1.97 1.97 0 1 1-2.785-2.785L30.106.616a1.97 1.97 0 0 1 2.785 0l11.157 11.156a1.97 1.97 0 0 1-1.392 3.363z" />
          <path
            d="M31.5 36.791a1.97 1.97 0 0 1-1.969-1.969V2.01a1.97 1.97 0 0 1 3.938 0v32.812a1.97 1.97 0 0 1-1.969 1.969z" />
          <path
            d="M55.781 63.041H7.22A7.225 7.225 0 0 1 0 55.822V41.385a4.599 4.599 0 0 1 4.594-4.594h7.234a4.567 4.567 0 0 1 4.402 3.276l2.814 9.382a.658.658 0 0 0 .628.467h23.656a.658.658 0 0 0 .628-.467l2.814-9.385a4.572 4.572 0 0 1 4.402-3.273h7.234A4.599 4.599 0 0 1 63 41.385v14.437a7.225 7.225 0 0 1-7.219 7.219zM4.594 40.729a.656.656 0 0 0-.657.656v14.437a3.286 3.286 0 0 0 3.282 3.282H55.78a3.286 3.286 0 0 0 3.282-3.282V41.385a.656.656 0 0 0-.657-.656h-7.234a.65.65 0 0 0-.628.467L47.73 50.58a4.628 4.628 0 0 1-4.402 3.274H19.672a4.567 4.567 0 0 1-4.402-3.276l-2.814-9.382a.65.65 0 0 0-.628-.467H4.594z" />
        </g>
      </svg>
      <div class="dragndropText">
        <h3>Drag and drop files here</h3>
        <h3>or</h3>
        <label class="label-file" for="fileDropRef">Browse for file</label>
      </div>
    </div>
  </div>

  <!-- New Tabbed Table View -->
  <div class="row m-t-60 backgroundBlur">
    <div class="col-md-12">
      <div class="table-header">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <a href="javascript:void(0)" class="nav-link" [class.active]="activeTab==='recent'" (click)="setActiveTab('recent')">Recent Files</a>
          </li>
          <li class="nav-item" role="presentation">
            <a href="javascript:void(0)" class="nav-link" [class.active]="activeTab==='folders'" (click)="setActiveTab('folders')">All Folders</a>
          </li>
          <li class="nav-item" role="presentation">
            <a href="javascript:void(0)" class="nav-link" [class.active]="activeTab==='files'" (click)="setActiveTab('files')">All Files</a>
          </li>
          <li class="nav-item" role="presentation" *ngIf="showShareListDiv">
            <a href="javascript:void(0)" class="nav-link" [class.active]="activeTab==='shared'" (click)="setActiveTab('shared')">Shared</a>
          </li>
        </ul>
        <div class="table-actions">
          <!-- NAME/TAG toggle -->
          <label class="toggle-label m-r-10">
            <input type="checkbox" />
            <span class="back" style="top: 0">
              <span class="toggle"></span>
              <span class="label on" (click)="getTypeToSerch($event)">NAME</span>
              <span class="label off" (click)="getTypeToSerch($event)">TAG</span>
            </span>
          </label>

          <!-- Inline search -->
          <div class="table-search">
            <div class="input-group add-on">
            <input class="form-control" [formControl]="uploadForm.controls['searchByValue']" placeholder="Search" name="srch-term" id="srch-term-inline" type="text" (keyup)="searchFileName($event)" />
            <div class="input-group-btn">
              <i class="fa fa-search" style="font-size: 18px"></i>
            </div>
            </div>
            <div *ngIf="searchResultsList.length > 0" class="search-result">
              <div *ngFor="let searchResult of searchResultsList" style="cursor:pointer;">
                <i aria-hidden="true" [ngClass]="searchResult.recordType == 'file' ? getFileIcon(searchResult.recordName) : 'fa fa-folder-open'"></i>
                <span (click)="serachFileRedirect(searchResult)">{{searchResult.recordName}}</span>
              </div>
            </div>
          </div>

          <!-- Create folder button (moved here) -->
          <button class="button button1 m-l-10" *ngIf="!sharedFolder" (click)="addNewFolder()">
            <i class="fa fa-plus" aria-hidden="true"></i> FOLDER
          </button>
        </div>
      </div>

      <div class="tab-content p-10 modern-table-wrapper">
        <!-- Recent Files Table -->
        <div [hidden]="activeTab!=='recent'">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th style="width:40px" *ngIf="isDeleteAllSelected"></th>
                <th>Name</th>
                <th style="width:120px" class="align-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of pagedRecentFiles; let i = index" [title]="file.recordName">
                <td *ngIf="isDeleteAllSelected">
                  <input type="checkbox" (click)="getCheckedRecords($event, file)" />
                </td>
                <td (click)="openFileInNewTab(file)" style="cursor:pointer">
                  <i [ngClass]="getFileIcon(file.recordName)" aria-hidden="true"></i> {{ file.recordName }}
                </td>
                <td class="align-right">
                  <i class="fa fa-eye action-icon" aria-hidden="true" title="View" data-toggle="tooltip" (click)="openFileInNewTab(file)" (keydown.enter)="openFileInNewTab(file)" (keydown.space)="openFileInNewTab(file); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-share-alt action-icon" *ngIf="allowDownloadAccess" aria-hidden="true" title="Share" data-toggle="tooltip" (click)="shareFileDialogBox(file, i)" (keydown.enter)="shareFileDialogBox(file, i)" (keydown.space)="shareFileDialogBox(file, i); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-pencil action-icon" *ngIf="allowDownloadAccess" aria-hidden="true" title="Rename" data-toggle="tooltip" (click)="renameFileDialogBox(file, i, 'recentFile')" (keydown.enter)="renameFileDialogBox(file, i, 'recentFile')" (keydown.space)="renameFileDialogBox(file, i, 'recentFile'); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-tag action-icon" *ngIf="allowDownloadAccess" aria-hidden="true" title="Tags" data-toggle="tooltip" (click)="openTagPopupComponent(file, i, 'recentFile')" (keydown.enter)="openTagPopupComponent(file, i, 'recentFile')" (keydown.space)="openTagPopupComponent(file, i, 'recentFile'); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fas fa-trash-alt action-icon" *ngIf="allowDownloadAccess" aria-hidden="true" title="Delete" data-toggle="tooltip" (click)="confirmDeleteFileDialogBox(file, i)" (keydown.enter)="confirmDeleteFileDialogBox(file, i)" (keydown.space)="confirmDeleteFileDialogBox(file, i); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-download action-icon" aria-hidden="true" title="Download" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="downloadGFMFileDialogBox(file, i, 'recentFile', 'false')" (keydown.enter)="downloadGFMFileDialogBox(file, i, 'recentFile', 'false')" (keydown.space)="downloadGFMFileDialogBox(file, i, 'recentFile', 'false'); $event.preventDefault()" tabindex="0" role="button"></i>
                </td>
              </tr>
              <tr *ngIf="pagedRecentFiles.length===0">
                <td [attr.colspan]="isDeleteAllSelected?3:2" class="align-center">No records</td>
              </tr>
            </tbody>
          </table>
          <div class="table-pagination">
            <div class="pagination">
            <a class="prev" href="javascript:void(0)" (click)="prevPage('recent')" [class.disabled]="!canPrev('recent')">Prev</a>
            <div class="pages">
              <a href="javascript:void(0)" class="active">{{recentPage}}</a>
              <a href="javascript:void(0)">/ {{ totalPages(recentFileList||[]) }}</a>
            </div>
            <a class="next" href="javascript:void(0)" (click)="nextPage('recent')" [class.disabled]="!canNext('recent')">Next</a>
            </div>
          </div>
        </div>

        <!-- All Folders Table -->
        <div [hidden]="activeTab!=='folders'">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th style="width:40px" *ngIf="isDeleteAllSelected"></th>
                <th>Name</th>
                <th style="width:120px" class="align-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let folder of pagedFolders; let i = index" [title]="folder.recordName" class="folder-row">
                <td *ngIf="isDeleteAllSelected">
                  <input type="checkbox" (click)="getCheckedRecords($event, folder)" />
                </td>
                <td (click)="sharedFolder ? getSelectedFolderFileList(folder, 'true', i) : getSelectedFolderFileList(folder, 'false', i)" style="cursor:pointer">
                  <i class="fa fa-folder-open btn-yellow" aria-hidden="true"></i> 
                  <span class="folder-name">{{ folder.recordName }}</span>
                </td>
                <td class="align-right" *ngIf="sharedFolder == undefined && isSharedFolder == undefined || isSharedFolder == 'false'">
                  <i class="fa fa-share-alt action-icon" aria-hidden="true" title="Share" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="shareFileDialogBox(folder, i)" (keydown.enter)="shareFileDialogBox(folder, i)" (keydown.space)="shareFileDialogBox(folder, i); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-pencil action-icon" aria-hidden="true" title="Rename" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="renameFolderDialogBox(folder, i, 'folder')" (keydown.enter)="renameFolderDialogBox(folder, i, 'folder')" (keydown.space)="renameFolderDialogBox(folder, i, 'folder'); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-tag action-icon" aria-hidden="true" title="Tags" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="openTagPopupComponent(folder, i, 'allFiles')" (keydown.enter)="openTagPopupComponent(folder, i, 'allFiles')" (keydown.space)="openTagPopupComponent(folder, i, 'allFiles'); $event.preventDefault()" tabindex="0" role="button"></i>
                  <!-- <i class="fa fa-arrows-alt action-icon" aria-hidden="true" title="Move" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="openMoveDialog(folder, i)"></i> -->
                  <i class="fas fa-trash-alt action-icon" aria-hidden="true" title="Delete" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="confirmDeleteFolderDialogBox(folder)" (keydown.enter)="confirmDeleteFolderDialogBox(folder)" (keydown.space)="confirmDeleteFolderDialogBox(folder); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-download action-icon" aria-hidden="true" title="Download" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="downloadGFMFileDialogBox(folder, i, 'allFiles', 'false')" (keydown.enter)="downloadGFMFileDialogBox(folder, i, 'allFiles', 'false')" (keydown.space)="downloadGFMFileDialogBox(folder, i, 'allFiles', 'false'); $event.preventDefault()" tabindex="0" role="button"></i>
                </td>
                <td class="align-right" *ngIf="sharedFolder == 'true' || isSharedFolder == 'true'">
                  <ng-container *ngFor="let permisson of folder.recordSharedWith; let ix = index">
                    <ng-container *ngIf="permisson.uniqueUserId == loggedInUserUniqueId">
                      <ng-container *ngFor="let p of permisson.permissions">
                        <a class="m-l-10" *ngIf="p!='view' && p!='annotate'" (click)="shareCheckType(folder, ix, p)" style="cursor:pointer">{{p | titlecase}}</a>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <a class="m-l-10" (click)="confirmDeleteSharedFileDialogBox(folder, i)" style="cursor:pointer">Delete</a>
                </td>
              </tr>
              <tr *ngIf="pagedFolders.length===0">
                <td [attr.colspan]="isDeleteAllSelected?3:2" class="align-center">No records</td>
              </tr>
            </tbody>
          </table>
          <div class="table-pagination">
            <div class="pagination">
            <a class="prev" href="javascript:void(0)" (click)="prevPage('folders')" [class.disabled]="!canPrev('folders')">Prev</a>
            <div class="pages">
              <a href="javascript:void(0)" class="active">{{foldersPage}}</a>
              <a href="javascript:void(0)">/ {{ totalPages(folderList||[]) }}</a>
            </div>
            <a class="next" href="javascript:void(0)" (click)="nextPage('folders')" [class.disabled]="!canNext('folders')">Next</a>
            </div>
          </div>
        </div>

        <!-- All Files Table -->
        <div [hidden]="activeTab!=='files'">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th style="width:40px" *ngIf="isDeleteAllSelected"></th>
                <th>Name</th>
                <th style="width:120px" class="align-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of pagedFiles; let i = index" [title]="file.recordName">
                <td *ngIf="isDeleteAllSelected">
                  <input type="checkbox" (click)="getCheckedRecords($event, file)" />
                </td>
                <td (click)="openFileInNewTab(file)" style="cursor:pointer">
                  <i [ngClass]="getFileIcon(file.recordName)" aria-hidden="true"></i> 
                  <span class="file-name">{{ file.recordName }}</span>
                </td>
                <td class="align-right" *ngIf="(sharedFolder == undefined && isSharedFolder == undefined) || isSharedFolder == 'false'">
                  <i *ngIf="allowDownloadAccess" class="fa fa-share-alt action-icon" aria-hidden="true" title="Share" data-toggle="tooltip" (click)="shareFileDialogBox(file, i)" (keydown.enter)="shareFileDialogBox(file, i)" (keydown.space)="shareFileDialogBox(file, i); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i *ngIf="allowDownloadAccess" class="fa fa-pencil action-icon" aria-hidden="true" title="Rename" data-toggle="tooltip" (click)="renameFileDialogBox(file, i, 'allFiles')" (keydown.enter)="renameFileDialogBox(file, i, 'allFiles')" (keydown.space)="renameFileDialogBox(file, i, 'allFiles'); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i *ngIf="allowDownloadAccess" class="fa fa-tag action-icon" aria-hidden="true" title="Tags" data-toggle="tooltip" (click)="openTagPopupComponent(file, i, 'allFiles')" (keydown.enter)="openTagPopupComponent(file, i, 'allFiles')" (keydown.space)="openTagPopupComponent(file, i, 'allFiles'); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i *ngIf="allowDownloadAccess" class="fa fa-arrows-alt action-icon" aria-hidden="true" title="Move" data-toggle="tooltip" (click)="openMoveDialog(file, i)" (keydown.enter)="openMoveDialog(file, i)" (keydown.space)="openMoveDialog(file, i); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i *ngIf="allowDownloadAccess" class="fas fa-trash-alt action-icon" aria-hidden="true" title="Delete" data-toggle="tooltip" (click)="confirmDeleteFileDialogBox(file, i)" (keydown.enter)="confirmDeleteFileDialogBox(file, i)" (keydown.space)="confirmDeleteFileDialogBox(file, i); $event.preventDefault()" tabindex="0" role="button"></i>
                  <i class="fa fa-download action-icon" aria-hidden="true" title="Download" data-toggle="tooltip" *ngIf="allowDownloadAccess" (click)="downloadGFMFileDialogBox(file, i, 'allFiles', 'false')" (keydown.enter)="downloadGFMFileDialogBox(file, i, 'allFiles', 'false')" (keydown.space)="downloadGFMFileDialogBox(file, i, 'allFiles', 'false'); $event.preventDefault()" tabindex="0" role="button"></i>
                </td>
                <td class="align-right" *ngIf="sharedFolder == 'true' || isSharedFolder == 'true'">
                  <ng-container *ngFor="let permisson of file.recordSharedWith; let ix = index">
                    <ng-container *ngIf="permisson.uniqueUserId == loggedInUserUniqueId">
                      <ng-container *ngFor="let p of permisson.permissions">
                        <a class="m-l-10" *ngIf="p!='view' && p!='annotate'" (click)="shareCheckType(file, ix, p)" style="cursor:pointer">{{p | titlecase}}</a>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <a class="m-l-10" (click)="confirmDeleteSharedFileDialogBox(file, i)" style="cursor:pointer">Delete</a>
                  <a class="m-l-10" *ngIf="allowDownloadAccess" (click)="downloadGFMFileDialogBox(file, i, 'allFiles', 'false')" style="cursor:pointer">Download</a>
                </td>
              </tr>
              <tr *ngIf="pagedFiles.length===0">
                <td [attr.colspan]="isDeleteAllSelected?3:2" class="align-center">No records</td>
              </tr>
            </tbody>
          </table>
          <div class="table-pagination">
            <div class="pagination">
            <a class="prev" href="javascript:void(0)" (click)="prevPage('files')" [class.disabled]="!canPrev('files')">Prev</a>
            <div class="pages">
              <a href="javascript:void(0)" class="active">{{filesPage}}</a>
              <a href="javascript:void(0)">/ {{ totalPages(fileList||[]) }}</a>
            </div>
            <a class="next" href="javascript:void(0)" (click)="nextPage('files')" [class.disabled]="!canNext('files')">Next</a>
            </div>
          </div>
        </div>

        <!-- Shared Files and Folders Table -->
        <div [hidden]="activeTab!=='shared'">
          <table class="table table-striped table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th style="width:120px" class="align-right">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let file of pagedShared; let i = index" [title]="file.recordName">
                <td>
                  <span *ngIf="file.recordType == 'file'">
                    <i aria-hidden="true" [ngClass]="getFileIcon(file.recordName)"></i> 
                    <span class="file-name">{{ sendShortName(file.recordName) }}</span>
                  </span>
                  <span *ngIf="file.recordType == 'folder'" (click)="getSelectedFolderFileList(file, 'true', i)" style="cursor: pointer">
                    <i aria-hidden="true" class="fa fa-folder-open btn-yellow"></i> 
                    <span class="folder-name">{{ sendShortName(file.recordName) }}</span>
                  </span>
                </td>
                <td class="align-right">
                  <i class="fa fa-eye action-icon" aria-hidden="true" title="View" data-toggle="tooltip" (click)="openFileInNewTab(file)" (keydown.enter)="openFileInNewTab(file)" (keydown.space)="openFileInNewTab(file); $event.preventDefault()" tabindex="0" role="button"></i>
                  <ng-container *ngFor="let permisson of file.recordSharedWith; let ix = index">
                    <ng-container *ngIf="permisson.uniqueUserId == loggedInUserUniqueId">
                      <ng-container *ngFor="let p of permisson.permissions">
                        <i class="action-icon" [ngClass]="{
                            'fa fa-download': p==='download',
                            'fa fa-share-alt': p==='share',
                            'fas fa-trash-alt': p==='delete'
                          }" *ngIf="p != 'view' && p != 'annotate'" [title]="p | titlecase" data-toggle="tooltip" (click)="shareCheckType(file, ix, p)" (keydown.enter)="shareCheckType(file, ix, p)" (keydown.space)="shareCheckType(file, ix, p); $event.preventDefault()" tabindex="0" role="button"></i>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                  <i class="fas fa-trash-alt action-icon" title="Remove Shared" data-toggle="tooltip" (click)="confirmDeleteSharedFileDialogBox(file, i)" (keydown.enter)="confirmDeleteSharedFileDialogBox(file, i)" (keydown.space)="confirmDeleteSharedFileDialogBox(file, i); $event.preventDefault()" tabindex="0" role="button"></i>
                </td>
              </tr>
              <tr *ngIf="pagedShared.length===0">
                <td colspan="2" class="align-center">No shared records</td>
              </tr>
            </tbody>
          </table>
          <div class="table-pagination">
            <div class="pagination">
              <a class="prev" href="javascript:void(0)" (click)="prevPage('shared')" [class.disabled]="!canPrev('shared')">Prev</a>
              <div class="pages">
                <a href="javascript:void(0)" class="active">{{sharedPage}}</a>
                <a href="javascript:void(0)">/ {{ totalPages(filterShareList(shareList||[])) }}</a>
              </div>
              <a class="next" href="javascript:void(0)" (click)="nextPage('shared')" [class.disabled]="!canNext('shared')">Next</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- modal for folder configuration -->
  <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
    <div class="modal-dialog modal-s" role="document">
      <div class="modal-content">
        <div class="modal-header" style="justify-content: unset !important">
          <h4 class="modal-title" id="myModalLabel">Create Folder</h4>
          <button type="button" class="close" style="right: 5px; position: absolute" data-dismiss="modal"
            (click)="closeForm('myModal')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <form [formGroup]="uploadForm" novalidate>
          <div class="modal-body pt-3 pb-3 mod-label">
            <div class="form-group d-inline-flex col-lg-12 p-0">
              <label class="folderLabel label col-lg-3 p-0 text-left">
                <span style="vertical-align: -webkit-baseline-middle">Folder Name
                </span>
              </label>
              <div class="col-lg-9">
                <input class="form-control" placeholder="enter folder name" type="text"
                  [formControl]="uploadForm.controls['folderName']" name="folderName" [value]="folderName"
                  (keyup)="getFolderName($event)" (change)="getFolderName($event)" style="margin-bottom: 10px"
                  required />
                <div *ngIf="
                    uploadForm.controls['folderName'].hasError('required') &&
                    uploadForm.controls['folderName'].touched
                  " class="form-control-error-custom p-0 mt-1">
                  Folder Name required.
                </div>
                <div *ngIf="
                    !uploadForm.controls['folderName'].valid &&
                    !uploadForm.controls['folderName'].hasError('required') &&
                    uploadForm.controls['folderName'].touched
                  " class="form-control-error-custom">
                  (Valid characters are A-Z a-z 0-9 _ - and space)
                </div>
                <div *ngIf="recordNameAlreadyPresent" class="form-control-error-custom p-0 mt-1">
                  Folder Name Already Present
                </div>
              </div>
            </div>
            <div class="form-group d-inline-flex col-lg-12 p-0">
              <label class="folderLabel label col-lg-3 p-0 text-left">
                <span style="vertical-align: -webkit-baseline-middle">Upload document
                </span>
              </label>
              <div class="col-lg-9">
                <input class="form-control" placeholder="upload file" type="file" multiple
                  (change)="multipleFileEvent($event)" [formControl]="
                    uploadForm.controls['multipleFileDocumentForUpload']
                  " name="{{ multipleFileDocumentForUpload }}" style="width: 93px"
                  accept=".xlsx, .xls, .csv, .jpg, .jpeg, .png, .doc, .docx, .txt, .pdf, .ppt, .mp4" />
                <span style="color: red" *ngIf="!multifileExtension">Please upload valid file format.</span>
              </div>
            </div>
            <div *ngFor="let file of uploadMultipleFileDocument; let i = index">
              <span>{{ file.name }}</span>
              <span class="fa fa-times" (click)="deleteSelectedFile($event, file, i)"></span>
            </div>

            <div class="col-lg-12 p-0" *ngIf="showAddTagButtonForCreateFolder">
              <div class="col-lg-10" *ngIf="showAddTagDiv" style="
                  border: 1px solid lightgrey;
                  padding: 5px;
                  min-height: inherit !important;
                ">
                <button class="btn btn-sm btn-primary" style="margin-right: 10px; margin-bottom: 5px"
                  *ngFor="let tag of selectedTagsForFolder" (click)="removeSelectedTagsForFolder(tag)">
                  {{ tag.label }}
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="col-lg-2" style="float: right">
                <button class="btn btn-sm btn-primary" (click)="tagPopForFolders()">
                  Add Tags
                </button>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" (click)="saveFolderNameWithFileUplaod()" [disabled]="
                (recordNameAlreadyPresent && !uploadForm.valid) ||
                disabledOnclick ||
                !multifileExtension ||
                uploadForm.controls['folderName'].hasError('required')
              ">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- model for  folder created successfully -->
  <div class="modal fade" id="folderCreatedSuccessfully" role="dialog" aria-labelledby="folderCreatedSuccessfully">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="folderCreatedSuccessfully">
            <i class="mr-2"></i>Success
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Folder created successfully</p>
        </div>
      </div>
    </div>
  </div>

  <!-- shared file deleted successfully -->
  <div class="modal fade" id="sharedFileDeleteSuccessfully" role="dialog"
    aria-labelledby="sharedFileDeleteSuccessfully">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sharedFileDeleteSuccessfully">
            <i class="mr-2"></i>Success
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Shared File Deleted successfully</p>
        </div>
      </div>
    </div>
  </div>

  <!-- shared folder deleted successfully -->
  <div class="modal fade" id="sharedFolderDeleteSuccessfully" role="dialog"
    aria-labelledby="sharedFolderDeleteSuccessfully">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="sharedFolderDeleteSuccessfully">
            <i class="mr-2"></i>Success
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Shared Folder Deleted successfully</p>
        </div>
      </div>
    </div>
  </div>

  <!-- file rename successfully -->
  <div class="modal fade" id="renameFolderModalSuccessfull" role="dialog"
    aria-labelledby="renameFolderModalSuccessfull">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="renameFolderModalSuccessfull">
            <i class="mr-2"></i>Success
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>File Rename successfully</p>
        </div>
      </div>
    </div>
  </div>

  <!--modal for rename File Name -->
  <div class="modal fade" id="renameFileModal" role="dialog" aria-labelledby="renameFileModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="renameFileModal">
            <i class="mr-2"></i>Rename File Name
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pt-3 pb-3 mod-label">
          <form [formGroup]="uploadForm" novalidate>
            <div class="form-group d-inline-flex col-lg-12 p-0">
              <label class="folderLabel label col-lg-3 p-0 text-left">
                <span style="vertical-align: -webkit-baseline-middle">File Name
                </span>
              </label>
              <div class="col-lg-9">
                <input class="form-control" placeholder="enter file name" type="text"
                  [formControl]="uploadForm.controls['fileName']" name="fileName" [value]="fileName"
                  (keyup)="getNewFileName($event)" (change)="getNewFileName($event)" style="margin-bottom: 10px"
                  required />
                <div *ngIf="
                    uploadForm.controls['fileName'].hasError('required') &&
                    uploadForm.controls['fileName'].touched
                  " class="form-control-error-custom p-0 mt-1">
                  File Name required.
                </div>
                <div *ngIf="fileAfterRenameSame" class="form-control-error-custom p-0 mt-1">
                  File Name Already Present
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" (click)="renameFileName()"
            [disabled]="fileAfterRenameSame">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--modal for rename Folder Name -->
  <div class="modal fade" id="renameFolderModal" role="dialog" aria-labelledby="renameFolderModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="renameFolderModal">
            <i class="mr-2"></i>Rename Folder Name
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pt-3 pb-3 mod-label">
          <form [formGroup]="uploadForm" novalidate>
            <div class="form-group d-inline-flex col-lg-12 p-0">
              <label class="folderLabel label col-lg-3 p-0 text-left">
                <span style="vertical-align: -webkit-baseline-middle">Folder Name
                </span>
              </label>
              <div class="col-lg-9">
                <input class="form-control" placeholder="enter folder name" type="text" name="folderNameAfterRename"
                  [formControl]="uploadForm.controls['folderNameAfterRename']" [value]="folderNameAfterRename"
                  (keyup)="getNewFolderName($event)" (change)="getNewFolderName($event)" style="margin-bottom: 10px"
                  required />
                <div *ngIf="
                    uploadForm.controls['folderNameAfterRename'].hasError(
                      'required'
                    ) && uploadForm.controls['folderNameAfterRename'].touched
                  " class="form-control-error-custom p-0 mt-1">
                  Folder Name required.
                </div>
                <div *ngIf="
                    !uploadForm.controls['folderNameAfterRename'].valid &&
                    !uploadForm.controls['folderNameAfterRename'].hasError(
                      'required'
                    ) &&
                    uploadForm.controls['folderNameAfterRename'].touched
                  " class="form-control-error-custom">
                  (Valid characters are A-Z a-z 0-9 _ - and space)
                </div>
                <div *ngIf="folderNamePresentWhileRename" class="form-control-error-custom p-0 mt-1">
                  Folder Name Already Present
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" (click)="renameFolderName()"
            [disabled]="
              folderNamePresentWhileRename ||
              !uploadForm.controls['folderNameAfterRename'].valid
            ">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--confirm delete file dialogbox-->
  <div class="modal fade" id="deleteFileModel" role="dialog" aria-labelledby="deleteFileModel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteFileModel">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this file?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" (click)="confirmDeleteFile()">
            Confirm
          </button>
          <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
            (click)="closeForm('deleteFileModel')">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- confirm delete share file modal -->
  <div class="modal fade" id="deleteSharedFileModel" role="dialog" aria-labelledby="deleteSharedFileModel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteSharedFileModel">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this file?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" (click)="confirmDeleteSharedFile()">
            Confirm
          </button>
          <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
            (click)="closeForm('deleteSharedFileModel')">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--confirm delete folder dialogbox-->
  <div class="modal fade" id="deleteFolderModel" role="dialog" aria-labelledby="deleteFolderModel">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="deleteFolderModel">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this folder?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" (click)="confirmDeleteFolder()">
            Confirm
          </button>
          <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
            (click)="closeForm('deleteFolderModel')">
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>

  <!--modal for share file -->
  <div class="modal fade" id="shareFileModal" role="dialog" aria-labelledby="shareFileModal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="shareFileModal">
            <i class="mr-2"></i>Share
          </h5>
          <button class="btn btn-primary btn-sm" style="float: right" type="button" (click)="shareRecords()">
            Done
          </button>
        </div>
        <div class="modal-body pt-3 pb-3 mod-label">
          <div *ngFor="let user of userListToBind; let i = index">
            <span>{{ user.label }}</span>
            <div>
              <form action="/action_page.php">
                <div class="form-check-inline">
                  <label class="form-check-label" for="check1">
                    <input type="checkbox" class="form-check-input" id="{{ 'view' + i }}" name="vehicle1"
                      value="something" />view
                  </label>
                </div>
                <div class="form-check-inline">
                  <label class="form-check-label" for="check2">
                    <input type="checkbox" class="form-check-input" id="{{ 'annotate' + i }}" name="vehicle2"
                      value="something" />annotate
                  </label>
                </div>
                <div class="form-check-inline">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" id="{{ 'share' + i }}" />share
                  </label>
                </div>
                <div class="form-check-inline">
                  <label class="form-check-label" for="check2">
                    <input type="checkbox" class="form-check-input" id="{{ 'delete' + i }}" name="vehicle2"
                      value="something" />delete
                  </label>
                </div>
              </form>
            </div>
            <hr />
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>

  <!--confirm delete multiple records dialogbox-->
  <div class="modal fade" id="confirmMultipleDelete" role="dialog" aria-labelledby="confirmMultipleDelete">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="confirmMultipleDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Are you sure you want to delete this item?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-sm" (click)="deleteMultipleRecords()">
            Yes
          </button>
          <button type="button" class="btn btn-default btn-sm" data-dismiss="modal"
            (click)="closeForm('confirmMultipleDelete')">
            No
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- model for uplaoded file already present -->
  <div class="modal fade" id="uploadedSingleFileAlreadyPresent" role="dialog"
    aria-labelledby="uploadedSingleFileAlreadyPresent">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="uploadedSingleFileAlreadyPresent">
            <i class="fa fa-question-circle-o mr-2"></i>
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>Uploaded File Already Present</p>
        </div>
      </div>
    </div>
  </div>

  <!-- recent files (legacy cards) hidden under table view but preserved) -->
  <div *ngIf="recentFileList && false" class="backgroundBlur">
    <div class="row m-t-60">
      <div class="col-md-12">
        <h4>Recent Files</h4>
      </div>
    </div>

    <div class="row m-t-10 m-b-10" id="test1">
      <div class="col-md-3 col-sm-6 white-box m-b-20" style="position:relative"
        *ngFor="let file of recentFileList;let i=index">
        <div class="wht-card p-10" data-toggle="tooltip" [title]='file.recordName'>
          <i class="fa fa-ellipsis-h" aria-hidden="true" style="float:right;"
            (contextmenu)="rightClick($event,file,i,'recentFile')"
            (click)="showRecentFileMenu(file,i,'recentFile')" *ngIf="allowDownloadAccess"></i>
          <div class="text-body"  >
            <p (click)="openFileInNewTab(file)">
              <span *ngIf="isDeleteAllSelected">
                <input name="selectrecord" type="checkbox" style="float: left; margin: 9px 7px 0 0; width: 25px"
                  (click)="getCheckedRecords($event, file)" />
              </span>
              <i aria-hidden="true" [ngClass]="getFileIcon(file.recordName)"></i>{{ sendShortName(file.recordName) }}
            </p>
          </div>
          <i *ngIf="file.recordName.split('.').slice(-1) == 'pdf'" aria-hidden="true" class="fa fa-eye fa-lg"
            style="float: right; margin-top:25px; cursor:pointer; " (click)="openFileInNewTab(file)">
          </i>
        </div>
        <div id="{{ 'recentFile' + i }}" class="hide dropdown clearfix rightMenu">
          <ul class="ulList">
            <li style="cursor: pointer">
              <a *ngIf="allowDownloadAccess" (click)="shareFileDialogBox(file, i)">Share</a>
            </li>
            <li style="cursor: pointer">
              <a *ngIf="allowDownloadAccess" (click)="renameFileDialogBox(file, i, 'recentFile')">Rename</a>
            </li>
            <li style="cursor: pointer">
              <a *ngIf="allowDownloadAccess" (click)="openTagPopupComponent(file, i, 'recentFile')">Tags</a>
            </li>
            <li style="cursor: pointer">
              <a *ngIf="allowDownloadAccess"(click)="confirmDeleteFileDialogBox(file, i)">Delete</a>
            </li>
            <li style="cursor: pointer">
              <a *ngIf="allowDownloadAccess"(click)="deleteSelectedRecords(file)">Delete selected</a>
            </li>
            <li style="cursor: pointer" *ngIf="allowDownloadAccess">
              <a (click)="
                  downloadGFMFileDialogBox(file, i, 'recentFile', 'false')
                ">Download</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- for folders (legacy cards) hidden under table view but preserved) -->
  <div *ngIf="folderList.length > 0 && false" class="backgroundBlur"> 
    <div class="row m-t-60">
      <div class="col-md-12">
        <h4>All Folders</h4>
      </div>
    </div>

    <div class="row m-t-10 m-b-10">
      <div class="col-md-3 col-sm-4 white-box m-b-20 text-center" style="position: relative"
        *ngFor="let folder of folderList; let i = index">
        <div data-toggle="tooltip" [title]="folder.recordName">
          <div class="p-10 record" style="
              background: #fff;
              overflow: hidden;
              padding: 0;
              box-shadow: 0 0 16px #c7c5d8;
              -webkit-box-shadow: 0 0 16px #c7c5d8;
              -moz-box-shadow: 0 0 16px #c7c5d8;
              -ms-box-shadow: 0 0 16px #c7c5d8;
            ">
            <span *ngIf="isDeleteAllSelected">
              <input name="vehicle1" type="checkbox" style="width: 30px; float: left; margin: 21px 0"
                (click)="getCheckedRecords($event, folder)" />
            </span>

            <i class="fa fa-ellipsis-h" *ngIf="allowDownloadAccess" aria-hidden="true" style="
                float: right;
                position: absolute;
                right: 20px;
                border: 1px solid #c5c1c1;
                padding: 5px;
                border-radius: 50%;
                height: 23px;
                width: 23px;
                text-align: center;
                top: 18px;
              " (contextmenu)="rightClick($event, folder, i, 'folder')"
              (click)="showFolderMenu(folder, i, 'folder')"></i>
            <div class="text-body" (click)="
                sharedFolder
                  ? getSelectedFolderFileList(folder, 'true', i)
                  : getSelectedFolderFileList(folder, 'false', i)
              " style="cursor: pointer">
              <p>
                <i class="fa fa-folder-open btn-yellow" aria-hidden="true"></i>
              </p>
              <p style="text-align: left;">
                {{ folder.recordName }}
              </p>
            </div>
          </div>
        </div>
        <div *ngIf="sharedFolder == undefined && isSharedFolder == undefined || isSharedFolder == 'false'">
          <div id="{{'folder'+i}}" class="hide dropdown clearfix rightMenu">
            <ul class="ulList">
              <li style="cursor: pointer">
                <a (click)="shareFileDialogBox(folder, i)">Share</a>
              </li>
              <li style="cursor: pointer">
                <a (click)="renameFolderDialogBox(folder, i, 'folder')">Rename</a>
              </li>
              <li style="cursor: pointer">
                <a (click)="openTagPopupComponent(folder, i, 'allFiles')">Tags</a>
              </li>
              <li style="cursor: pointer">
                <a (click)="confirmDeleteFolderDialogBox(folder)">Delete</a>
              </li>
              <li style="cursor: pointer">
                <a (click)="deleteSelectedRecords(folder)">Delete selected</a>
              </li>
              <li style="cursor: pointer" *ngIf="allowDownloadAccess">
                <a (click)="
                    downloadGFMFileDialogBox(folder, i, 'allFiles', 'false')
                  ">Download</a>
              </li>
            </ul>
          </div>
        </div>
        <div *ngIf="sharedFolder == 'true' || isSharedFolder == 'true'">
          <div id="{{ 'folder' + i }}" class="hide dropdown clearfix shareRightMenu rightMenu"
            style="right: 10px !important">
            <ul class="ulList">
              <div *ngFor="let permisson of folder.recordSharedWith; let i = index">
                <div *ngIf="permisson.uniqueUserId == loggedInUserUniqueId">
                  <div *ngFor="let p of permisson.permissions">
                    <li class="" style="cursor: pointer; padding: 5px 20px" *ngIf="p != 'view' && p != 'annotate'">
                      <a (click)="shareCheckType(folder, i, p)">{{
                        p | titlecase
                        }}</a>
                    </li>
                  </div>
                </div>
              </div>
              <li style="cursor: pointer">
                <a (click)="confirmDeleteSharedFileDialogBox(folder, i)">Delete</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- all files (legacy cards) hidden under table view but preserved) -->
  <div *ngIf="fileList.length > 0 && false" class="backgroundBlur">
    <div class="row m-t-60">
      <div class="col-md-12">
        <h4>All Files</h4>
      </div>
    </div>

    <div class="row m-t-10 m-b-10">
      <div class="col-md-3 col-sm-6 white-box m-b-20" style="position: relative"
        *ngFor="let file of fileList; let i = index">
        <div class="wht-card p-10" data-toggle="tooltip" [title]="file.recordName">
          <i class="fa fa-ellipsis-h" *ngIf="allowDownloadAccess" aria-hidden="true" style="float: right"
            (contextmenu)="rightClick($event, file, i, 'allFiles')" (click)="showAllFileMenu(file, i, 'allFiles')"></i>
          <div class="text-body">
            <p (click)="openFileInNewTab(file)">
              <span *ngIf="isDeleteAllSelected">
                <input name="selectrecord" type="checkbox" style="float: left; margin: 9px 7px 0 0; width: 25px"
                  (click)="getCheckedRecords($event, file)" />
              </span>
              <i _ngcontent-c1="" aria-hidden="true" [ngClass]="getFileIcon(file.recordName)"></i>{{ sendShortName(file.recordName) }}
            </p>
          </div>
          <i *ngIf="file.recordName.split('.').slice(-1) == 'pdf'" aria-hidden="true" class="fa fa-eye fa-lg"
            style="float: right; margin-top:25px; cursor:pointer; " (click)="openFileInNewTab(file)">
          </i>
        </div>

        <div *ngIf="
            (sharedFolder == undefined && isSharedFolder == undefined) ||
            isSharedFolder == 'false'
          ">
          <div id="{{ 'allFiles' + i }}" class="hide dropdown clearfix rightMenu">
            <ul class="ulList">
              <li *ngIf="allowDownloadAccess" style="cursor: pointer">
                <a (click)="shareFileDialogBox(file, i)">Share</a>
              </li>
              <li *ngIf="allowDownloadAccess" style="cursor: pointer">
                <a (click)="renameFileDialogBox(file, i, 'allFiles')">Rename</a>
              </li>
              <li *ngIf="allowDownloadAccess" style="cursor: pointer">
                <a (click)="openTagPopupComponent(file, i, 'allFiles')">Tags</a>
              </li>
              <li *ngIf="allowDownloadAccess" style="cursor: pointer">
                <a (click)="confirmDeleteFileDialogBox(file, i)">Delete</a>
              </li>
              <li *ngIf="allowDownloadAccess" style="cursor: pointer">
                <a (click)="deleteSelectedRecords(file)">Delete selected</a>
              </li>
              <li style="cursor: pointer" *ngIf="allowDownloadAccess">
                <a (click)="
                    downloadGFMFileDialogBox(file, i, 'allFiles', 'false')
                  ">Download</a>
              </li>
            </ul>
          </div>
        </div>

        <div *ngIf="sharedFolder == 'true' || isSharedFolder == 'true'">
          <div id="{{ 'allFiles' + i }}" class="hide dropdown clearfix shareRightMenu rightMenu"
            style="right: 10px !important">
            <ul class="ulList">
              <div *ngFor="let permisson of file.recordSharedWith; let i = index">
                <div *ngIf="permisson.uniqueUserId == loggedInUserUniqueId">
                  <div *ngFor="let p of permisson.permissions">
                    <li class="" style="cursor: pointer; padding: 5px 20px" *ngIf="p != 'view' && p != 'annotate'">
                      <a (click)="shareCheckType(file, i, p)">{{
                        p | titlecase
                        }}</a>
                    </li>
                  </div>
                </div>
              </div>
              <li style="cursor: pointer">
                <a (click)="confirmDeleteSharedFileDialogBox(file, i)">Delete</a>
              </li>
              <li style="cursor: pointer" *ngIf="allowDownloadAccess">
                <a (click)="
                    downloadGFMFileDialogBox(file, i, 'allFiles', 'false')
                  ">Download</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- share files (legacy cards hidden; replaced by Shared tab) -->
  <div *ngIf="showShareListDiv && false" class="backgroundBlur">
    <div class="row m-t-60">
      <div class="col-md-12">
        <h4>Shared Files and Folders</h4>
      </div>
    </div>

    <div class="row m-t-10 m-b-10 right-po">
      <div class="col-md-3 col-sm-6 white-box m-b-20" style="position: relative"
        *ngFor="let file of filterShareList(shareList); let i = index">
        <div class="wht-card p-10" data-toggle="tooltip" [title]="file.recordName">
          <i class="fa fa-ellipsis-h" *ngIf="allowDownloadAccess" aria-hidden="true" style="float: right"
            (contextmenu)="rightClick($event, file, i, 'shareFiles')"
            (click)="showShareFileMenu(file, i, 'shareFiles')"></i>
          <div class="text-body">
            <p (click)="openFileInNewTab(file)">
              <span *ngIf="file.recordType == 'file'">
                <i aria-hidden="true" [ngClass]="getFileIcon(file.recordName)"></i>
                {{ sendShortName(file.recordName) }}</span>
              <span *ngIf="file.recordType == 'folder'" (click)="getSelectedFolderFileList(file, 'true', i)"
                style="cursor: pointer">
                <i aria-hidden="true" class="fa fa-folder-open btn-yellow"></i>
                {{ sendShortName(file.recordName) }}</span>
            </p>
          </div>
          <i *ngIf="file.recordName.split('.').slice(-1) == 'pdf'" aria-hidden="true" class="fa fa-eye fa-lg"
            style="float: right; margin-top:25px; cursor:pointer; " (click)="openFileInNewTab(file)">
          </i>
        </div>

        <div id="{{ 'shareFiles' + i }}" class="hide dropdown clearfix shareRightMenu rightMenu"
          style="right: 10px !important">
          <ul class="ulList">
            <div *ngFor="let permisson of file.recordSharedWith; let i = index">
              <div *ngIf="permisson.uniqueUserId == loggedInUserUniqueId">
                <div *ngFor="let p of permisson.permissions">
                  <li class="" style="cursor: pointer; padding: 5px 20px" *ngIf="p != 'view' && p != 'annotate'">
                    <a (click)="shareCheckType(file, i, p)">{{
                      p | titlecase
                      }}</a>
                  </li>
                </div>
              </div>
            </div>
            <li style="cursor: pointer" *ngIf="allowDownloadAccess">
              <a (click)="confirmDeleteSharedFileDialogBox(file, i)">Delete</a>
            </li>
            <li style="cursor:pointer;" *ngIf="allowDownloadAccess">
              <a (click)="downloadGFMFileDialogBox(file,i,'shareFiles','true')">Download</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- File Viewer Modal with iframe -->
<div *ngIf="showFileViewer" class="file-viewer-overlay" (click)="closeFileViewer()">
  <div class="file-viewer-modal" (click)="$event.stopPropagation()">
    <div class="file-viewer-header">
      <h4>{{ title }} 
        <span *ngIf="!allowDownloadAccess" class="badge badge-danger ml-2">READ ONLY</span>
      </h4>
      <button type="button" class="close" (click)="closeFileViewer()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="file-viewer-body" [ngClass]="{'read-only-mode': !allowDownloadAccess}">
      <iframe *ngIf="iframeURL" 
              #pdfIframe
              [src]="iframeURL" 
              frameborder="0" 
              width="100%" 
              height="600px"
              [ngClass]="{'read-only-iframe': !allowDownloadAccess}"
              [attr.sandbox]="!allowDownloadAccess ? 'allow-same-origin allow-scripts allow-forms' : 'allow-same-origin allow-scripts allow-forms allow-downloads allow-popups'"
              (load)="onIframeLoad($event)"
              (contextmenu)="!allowDownloadAccess && $event.preventDefault()"
              [style.pointer-events]="!allowDownloadAccess ? 'none' : 'auto'"></iframe>
      <!-- Invisible overlay to block interactions in read-only mode -->
      <div *ngIf="!allowDownloadAccess" class="iframe-interaction-blocker" 
           (contextmenu)="$event.preventDefault()"
           (mousedown)="$event.preventDefault()"
           (selectstart)="$event.preventDefault()"></div>
    </div>
    <div class="file-viewer-footer">
      <button type="button" class="btn btn-secondary" (click)="closeFileViewer()">Close</button>
    </div>
  </div>
</div>

<!-- Move File/Folder Modal -->
<div class="modal fade" id="moveFileModal" tabindex="-1" role="dialog" aria-labelledby="moveFileModalLabel" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="moveFileModalLabel">Move {{ selectedItemToMove?.recordType === 'file' ? 'File' : 'Folder' }}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="itemName">Item to Move:</label>
          <input type="text" class="form-control" id="itemName" [value]="selectedItemToMove?.recordName" readonly>
        </div>
        <div class="form-group">
          <label for="destinationFolder">Select Destination:</label>
          <select class="form-control" id="destinationFolder" [(ngModel)]="selectedDestinationFolder" [disabled]="showSpinner">
            <option value="">{{ showSpinner ? 'Loading folders...' : 'Choose a destination...' }}</option>
            <option *ngFor="let folder of availableFolders" [ngValue]="folder">
              {{ folder.isRoot ? '📁 Root Directory' : '📁 ' + getFolderDisplayName(folder) }}
            </option>
          </select>
          <div *ngIf="showSpinner" class="text-center mt-2">
            <small class="text-muted">Loading all folders...</small>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmMove()">Move</button>
      </div>
    </div>
  </div>

  <!-- Generic Success Modal (replicates folderCreatedSuccessfully style) -->
  <div class="modal fade" id="actionSuccessModal" role="dialog" aria-labelledby="actionSuccessModal" data-backdrop="false" data-keyboard="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="actionSuccessModal">
            <i class="mr-2"></i>Success
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ successMessage }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Generic Error Modal -->
  <div class="modal fade" id="actionErrorModal" role="dialog" aria-labelledby="actionErrorModal" data-backdrop="false" data-keyboard="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="actionErrorModal">
            <i class="mr-2"></i>Error
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <p>{{ errorMessage }}</p>
        </div>
      </div>
    </div>
  </div>
</div>


